"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getCharacterStringLength = exports.noop = exports.eachObject = void 0;

// 遍历对象
var eachObject = function eachObject() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  var key = '';

  for (key in data) {
    if (typeof callback !== 'undefined') {
      callback(key, data[key]);
    }
  }
}; // 空函数


exports.eachObject = eachObject;

var noop = function noop() {}; // 保存名称需要计算长度，默认为1


exports.noop = noop;

var getCharacterStringLength = function getCharacterStringLength() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.length;
};

exports.getCharacterStringLength = getCharacterStringLength;
var _default = {
  eachObject: eachObject,
  noop: noop,
  getCharacterStringLength: getCharacterStringLength
};
exports["default"] = _default;